export default "__VITE_ASSET__b3ad8958__"